export default __webpack_public_path__ + "dist/media/Date.12e0e84d.svg";